import React from 'react';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var InputCategory = function (props) { return (React.createElement(Form.Item, { label: 'Category', colon: false }, props.form.getFieldDecorator('categoryId', {
    initialValue: props.initialValue || '',
    rules: [{
            required: true,
            message: 'Please set a category for this team',
        }, {
            max: 255,
            message: 'Category is too long',
        }, {
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Select, { size: 'large', disabled: props.isDisabled || !!props.initialValue, showSearch: true, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: function (categoryId) {
        props.handleSetCategory(categoryId);
    } }, props.categories && props.categories.map(function (c) { return (!c.isTeamCategory
    ? null
    : React.createElement(Select.Option, { key: c.id, value: c.id }, c.name)); }))))); };
export default InputCategory;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormTeamPage/FormTeam/InputCategory.tsx
// module id = 1195
// module chunks = 0